import { useLocale } from "../contexts/LocaleContext";

export function CookiesPolicyPage() {
    const { t } = useLocale();

  return (
    <section className="wrapper legal-page">
      <h1>{t("legal.cookies.title")}</h1>
      <p>{t("legal.cookies.subtitle")}</p>
      <p>{t("legal.cookies.effectiveDate")}</p>

      <p>{t("legal.cookies.intro1")}</p>
      <p>{t("legal.cookies.intro2")}</p>

      <h2>{t("legal.cookies.section1.title")}</h2>
      <p>{t("legal.cookies.section1.text1")}</p>
      <p>{t("legal.cookies.section1.text2")}</p>
      <ul>
        <li>{t("legal.cookies.section1.item1")}</li>
        <li>{t("legal.cookies.section1.item2")}</li>
      </ul>

      <h2>{t("legal.cookies.section2.title")}</h2>
      <p>{t("legal.cookies.section2.text1")}</p>
      <ul>
        <li>{t("legal.cookies.section2.item1")}</li>
        <li>{t("legal.cookies.section2.item2")}</li>
        <li>{t("legal.cookies.section2.item3")}</li>
      </ul>
      <p>{t("legal.cookies.section2.text2")}</p>

      <h2>{t("legal.cookies.section3.title")}</h2>

      <h3>{t("legal.cookies.section3.necessary.title")}</h3>
      <p>{t("legal.cookies.section3.necessary.text1")}</p>
      <p>{t("legal.cookies.section3.necessary.examples")}</p>
      <ul>
        <li>{t("legal.cookies.section3.necessary.item1")}</li>
        <li>{t("legal.cookies.section3.necessary.item2")}</li>
        <li>{t("legal.cookies.section3.necessary.item3")}</li>
        <li>{t("legal.cookies.section3.necessary.item4")}</li>
        <li>{t("legal.cookies.section3.necessary.item5")}</li>
      </ul>
      <p>{t("legal.cookies.section3.necessary.text2")}</p>
      <p>{t("legal.cookies.section3.necessary.legalBasis")}</p>

      <h3>{t("legal.cookies.section3.analytics.title")}</h3>
      <p>{t("legal.cookies.section3.analytics.text1")}</p>
      <p>{t("legal.cookies.section3.analytics.collected")}</p>
      <ul>
        <li>{t("legal.cookies.section3.analytics.item1")}</li>
        <li>{t("legal.cookies.section3.analytics.item2")}</li>
        <li>{t("legal.cookies.section3.analytics.item3")}</li>
        <li>{t("legal.cookies.section3.analytics.item4")}</li>
        <li>{t("legal.cookies.section3.analytics.item5")}</li>
      </ul>
      <p>{t("legal.cookies.section3.analytics.services")}</p>
      <ul>
        <li>{t("legal.cookies.section3.analytics.service1")}</li>
        <li>{t("legal.cookies.section3.analytics.service2")}</li>
      </ul>
      <p>{t("legal.cookies.section3.analytics.legalBasis")}</p>
      <p>{t("legal.cookies.section3.analytics.retention")}</p>

      <h3>{t("legal.cookies.section3.functional.title")}</h3>
      <p>{t("legal.cookies.section3.functional.text1")}</p>
      <p>{t("legal.cookies.section3.functional.examples")}</p>
      <ul>
        <li>{t("legal.cookies.section3.functional.item1")}</li>
        <li>{t("legal.cookies.section3.functional.item2")}</li>
        <li>{t("legal.cookies.section3.functional.item3")}</li>
      </ul>
      <p>{t("legal.cookies.section3.functional.legalBasis")}</p>

      <h3>{t("legal.cookies.section3.marketing.title")}</h3>
      <p>{t("legal.cookies.section3.marketing.text1")}</p>
      <p>{t("legal.cookies.section3.marketing.examples")}</p>
      <ul>
        <li>{t("legal.cookies.section3.marketing.item1")}</li>
        <li>{t("legal.cookies.section3.marketing.item2")}</li>
        <li>{t("legal.cookies.section3.marketing.item3")}</li>
        <li>{t("legal.cookies.section3.marketing.item4")}</li>
      </ul>
      <p>{t("legal.cookies.section3.marketing.purpose")}</p>
      <ul>
        <li>{t("legal.cookies.section3.marketing.purpose1")}</li>
        <li>{t("legal.cookies.section3.marketing.purpose2")}</li>
        <li>{t("legal.cookies.section3.marketing.purpose3")}</li>
      </ul>
      <p>{t("legal.cookies.section3.marketing.legalBasis")}</p>

      <h2>{t("legal.cookies.section4.title")}</h2>
      <p>{t("legal.cookies.section4.text1")}</p>
      <p>{t("legal.cookies.section4.text2")}</p>

      <h3>{t("legal.cookies.section4.youtube.title")}</h3>
      <p>{t("legal.cookies.section4.youtube.text1")}</p>
      <p>{t("legal.cookies.section4.youtube.provider")}</p>
      <p>{t("legal.cookies.section4.youtube.privacy")}</p>

      <h3>{t("legal.cookies.section4.maps.title")}</h3>
      <p>{t("legal.cookies.section4.maps.text1")}</p>
      <p>{t("legal.cookies.section4.maps.provider")}</p>

      <h3>{t("legal.cookies.section4.social.title")}</h3>
      <p>{t("legal.cookies.section4.social.text1")}</p>
      <ul>
        <li>{t("legal.cookies.section4.social.item1")}</li>
        <li>{t("legal.cookies.section4.social.item2")}</li>
        <li>{t("legal.cookies.section4.social.item3")}</li>
        <li>{t("legal.cookies.section4.social.item4")}</li>
      </ul>
      <p>{t("legal.cookies.section4.social.text2")}</p>

      <h2>{t("legal.cookies.section5.title")}</h2>
      <p>{t("legal.cookies.section5.text1")}</p>
      <p>{t("legal.cookies.section5.text2")}</p>

      <h3>{t("legal.cookies.section5.stripe.title")}</h3>
      <p>{t("legal.cookies.section5.stripe.text1")}</p>
      <ul>
        <li>{t("legal.cookies.section5.stripe.item1")}</li>
        <li>{t("legal.cookies.section5.stripe.item2")}</li>
        <li>{t("legal.cookies.section5.stripe.item3")}</li>
      </ul>

      <h3>{t("legal.cookies.section5.paypal.title")}</h3>
      <p>{t("legal.cookies.section5.paypal.text1")}</p>

      <h3>{t("legal.cookies.section5.gofundme.title")}</h3>
      <p>{t("legal.cookies.section5.gofundme.text1")}</p>
      <p>{t("legal.cookies.section5.gofundme.text2")}</p>

      <h2>{t("legal.cookies.section6.title")}</h2>
      <p>{t("legal.cookies.section6.text1")}</p>
      <p>{t("legal.cookies.section6.text2")}</p>
      <ul>
        <li>{t("legal.cookies.section6.item1")}</li>
        <li>{t("legal.cookies.section6.item2")}</li>
        <li>{t("legal.cookies.section6.item3")}</li>
      </ul>

      <h2>{t("legal.cookies.section7.title")}</h2>
      <p>{t("legal.cookies.section7.text1")}</p>
      <p>{t("legal.cookies.section7.text2")}</p>
      <ul>
        <li>{t("legal.cookies.section7.item1")}</li>
        <li>{t("legal.cookies.section7.item2")}</li>
        <li>{t("legal.cookies.section7.item3")}</li>
      </ul>
      <p>{t("legal.cookies.section7.text3")}</p>

      <h2>{t("legal.cookies.section8.title")}</h2>
      <p>{t("legal.cookies.section8.text1")}</p>
      <p>{t("legal.cookies.section8.text2")}</p>
      <ul>
        <li>{t("legal.cookies.section8.item1")}</li>
        <li>{t("legal.cookies.section8.item2")}</li>
        <li>{t("legal.cookies.section8.item3")}</li>
        <li>{t("legal.cookies.section8.item4")}</li>
        <li>{t("legal.cookies.section8.item5")}</li>
      </ul>
      <p>{t("legal.cookies.section8.text3")}</p>

      <h2>{t("legal.cookies.section9.title")}</h2>
      <p>{t("legal.cookies.section9.text1")}</p>
      <ul>
        <li>{t("legal.cookies.section9.item1")}</li>
        <li>{t("legal.cookies.section9.item2")}</li>
        <li>{t("legal.cookies.section9.item3")}</li>
        <li>{t("legal.cookies.section9.item4")}</li>
        <li>{t("legal.cookies.section9.item5")}</li>
        <li>{t("legal.cookies.section9.item6")}</li>
        <li>{t("legal.cookies.section9.item7")}</li>
      </ul>
      <p>{t("legal.cookies.section9.text2")}</p>

      <h2>{t("legal.cookies.section10.title")}</h2>
      <p>{t("legal.cookies.section10.line1")}</p>
      <p>{t("legal.cookies.section10.line2")}</p>
      <p>{t("legal.cookies.section10.line3")}</p>
      <p>{t("legal.cookies.section10.line4")}</p>
      <p>{t("legal.cookies.section10.line5")}</p>
      <p>{t("legal.cookies.section10.line6")}</p>
    </section>
  );
}
